<template>
    <fci-dialog :title="this.$f.tc(MapCardTypeToData[cardType].name)" v-model="show">
        <iframe :src="iframeSrc"></iframe>
    </fci-dialog>
</template>

<script>
import FciDialog from '@/components/FciDialog'
import DialogMixin from '@/modules/fptai/mixins/DialogMixin'
import { CardType, MapCardTypeToData } from '@/utils/const'

const MapCardTypeToFileName = {
    [CardType.TEXT]: 'text_card',
    [CardType.GO_TO_STEP]: 'go_to_step_card',
    [CardType.QUICK_REPLY]: 'quick_reply_card',
    [CardType.IMAGE]: 'image_card',
    [CardType.CAROUSEL]: 'carousel_card',
    [CardType.CONFIG]: 'configure_memory_card',
    [CardType.JSON_API]: 'api_card',
    [CardType.FORM]: 'form_card',
    [CardType.REQUEST_HUMAN_SUPPORT]: 'request_human_support_card',
    [CardType.REQUEST_USER_LOCATION]: '',
    [CardType.EMAIL]: '',
    [CardType.GET_SENDER_ATTRIBUTE]: '',
    [CardType.UPDATE_SENDER_ATTRIBUTE]: '',
    [CardType.LUA_SCRIPT]: '',
    [CardType.TAG]: '',
    [CardType.ZALO_LIST_TEMPLATE]: '',
    [CardType.TICKET]: '',
    [CardType.SUGGEST]: ''
}

export default {
    name: 'CardHelp',
    components: { FciDialog },
    mixins: [DialogMixin],
    data () {
        return {
            MapCardTypeToData,
            MapCardTypeToFileName,
            cardType: CardType.TEXT,
            iframeSrc: null
        }
    },
    methods: {
        open (cardType) {
            this.cardType = cardType
            let fileName = MapCardTypeToFileName[cardType] || 'default'
            let locale = this.$appService.getLocale()
            this.iframeSrc = `/dm-helper/${fileName}_${locale}.html`
            this.show = true
        }
    }
}
</script>

<style scoped lang="scss">
iframe {
    border: none;
    width: 100%;
    height: 700px;

    *:not(i) {
        font-size: 14px;
        font-family: 'Open Sans', sans-serif;
        color: #151A3B;
    }
}
</style>
